/* loaded by smart-asset */
export default require("./9a~jcFHTVmh.svg")